function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M22.3316 5.83336C24.3946 7.93774 25.6666 10.8203 25.6666 14C25.6666 17.2174 24.3642 20.1307 22.2579 22.2413M5.83331 22.3317C3.67339 20.2142 2.33331 17.2636 2.33331 14C2.33331 10.7742 3.64257 7.85409 5.75868 5.74219",
  stroke: "#C471F8",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M18.9991 9.38461C20.2368 10.5685 21 12.1902 21 13.9792C21 15.7894 20.2186 17.4283 18.9547 18.6158M9.1 18.6666C7.80404 17.4754 7 15.8153 7 13.9792C7 12.1643 7.78555 10.5215 9.05522 9.33331",
  stroke: "#C471F8",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M15.9324 12.193C16.9775 12.9603 17.5 13.3439 17.5 14C17.5 14.6561 16.9775 15.0397 15.9324 15.8071C15.644 16.0188 15.3578 16.2183 15.0948 16.3844C14.8642 16.5303 14.603 16.681 14.3324 16.8291C13.2899 17.3997 12.7685 17.685 12.301 17.3691C11.8334 17.0532 11.7909 16.3919 11.706 15.0694C11.682 14.6953 11.6667 14.3287 11.6667 14C11.6667 13.6714 11.682 13.3047 11.706 12.9306C11.7909 11.6081 11.8334 10.9468 12.301 10.6309C12.7685 10.315 13.2899 10.6003 14.3324 11.1709C14.603 11.319 14.8642 11.4698 15.0948 11.6156C15.3578 11.7817 15.644 11.9812 15.9324 12.193Z",
  stroke: "#C471F8",
  strokeWidth: 2
});

const SvgInplayMob = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgInplayMob, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/inplay-mob.b2c5dc24.svg";
export { ForwardRef as ReactComponent };